<template>
  <div class="wrapper wrapper-content animated fadeInRight">
    <el-form
      :model="formData"
      ref="detailInfo"
      label-width="0px"
      class="demo-dynamic form-horizontal detailPage"
    >
      <el-tabs type="border-card" v-model="selectLang">
        <el-tab-pane
          :name="item.lang"
          :label="$t('message.' + item.lang)"
          v-for="(item, index) in formData.langMaps"
          :key="index"
        >
          <div class="panel-body">
            <div class="ibox-content">
              <div class="form-group">
                <label class="col-sm-2 control-label"> Status </label>
                <div class="col-sm-10">
                  <el-form-item
                    prop="status"
                    :rules="{
                      required: true,
                      message: $t('message.required'),
                      trigger: 'blur',
                    }"
                  >
                    <el-select v-model="selectStatus">
                      <el-option
                        v-for="item in [
                          { val: 1, text: 'Active' },
                          { val: 0, text: 'Disable' },
                        ]"
                        :key="item.val"
                        :label="item.text"
                        :value="item.val"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-2 control-label"> Title </label>
                <div class="col-sm-10">
                  <el-form-item
                    :prop="'langMaps.' + index + '.title'"
                    :rules="{
                      required: true,
                      message: $t('message.required'),
                      trigger: 'blur',
                    }"
                  >
                    <el-input v-model="item.title" show-word-limit></el-input>
                  </el-form-item>
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-2 control-label"> Jump Link </label>
                <div class="col-sm-10">
                  <el-form-item
                    :prop="'langMaps.' + index + '.url'"
                    :rules="{
                      required: true,
                      message: $t('message.required'),
                      trigger: 'blur',
                    }"
                  >
                    <el-input v-model="item.url" show-word-limit></el-input>
                  </el-form-item>
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-2 control-label"> Logo Image </label>
                <div class="col-sm-10">
                  <el-form-item
                    :prop="'langMaps.' + index + '.fileUrl'"
                    :rules="{
                      required: true,
                      message: $t('message.required'),
                      trigger: 'blur',
                    }"
                  >
                    <el-upload
                      :ref="'upload' + item.lang"
                      action="#"
                      class="avatar-uploader"
                      :show-file-list="false"
                      :auto-upload="false"
                      :multiple="false"
                      :http-request="uploadImg"
                      accept=".png, .jpg"
                      :on-change="handleUploadChange"
                      :on-success="formValidateAndSubmit"
                    >
                    <div slot="tip" v-if="uploadErr" style="color:red;font-size:10px;" class="el-upload__tip">The uploaded file should not exceed 5MB</div>
                    <!-- :on-error="handleErrorOfUpload" -->
                      <el-image
                        v-if="item.showFileUrl"
                        :src="item.showFileUrl"
                        class="avatar"
                        fit="contain"
                      ></el-image>
                      <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                    </el-upload>
                  </el-form-item>
                </div>
              </div>
              <div class="hr-line-dashed"></div>
              <div class="form-group">
                <div class="col-sm-12">
                  <div class="pull-right">
                    <el-button @click="handleSubmit" type="primary"
                      >Save</el-button
                    >
                    <el-button @click="handleBack">{{
                      $t("message.Cancel")
                    }}</el-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </el-form>
  </div>
</template>
<script>
import config from "../config";
import axios from "axios";

export default {
  mixins: [config.globalMixin],
  data() {
    return {
      id: "",
      selectStatus: "Active",
      formData: {
        status: 1,
        langMaps: [
          {
            title: "",
            fileUrl: "",
            url: "",
            lang: "en_US",
            showFileUrl: "",
          },
          {
            title: "",
            fileUrl: "",
            url: "",
            lang: "zh_CN",
            showFileUrl: "",
          },
          {
            title: "",
            fileUrl: "",
            url: "",
            lang: "zh_HK",
            showFileUrl: "",
          },
        ],
      },
      uploadImgSuccessCount:0,
      selectLang: "en_US",
      uploadErr:false
    };
  },
  computed: {
    baseURL() {
      return config.domain + "/";
    },
    userInfo() {
      return this.getAuthObj();
    },
  },

  created() {
    this.id = this.$route.query.id;
    if(this.id) this.intiPage()
  },
  mounted() {},
  methods: {
    async intiPage(){
      const param={
        ...this.userInfo,
        id:this.id
      }
      const {
            data: { result,status_code, status_message },
          } = await axios.post(
            this.baseURL + "websitePartnership/detail",
            param
          );
          if (status_code == "0") {
            this.formData=result
          } else {
            this.$store.getters.warning.warningMsg = status_message;
            this.$store.getters.warning.warningFalg = true;
          }
    },
    handleUploadChange(file) {
      if (file.status == "ready") {
        const url = URL.createObjectURL(file.raw);
        const currentLangData = this.formData.langMaps.find((i) => {
          return i.lang == this.selectLang;
        });
        currentLangData.showFileUrl = url;
      }
    },
    async getUploadUrl() {
      let { data } = await axios.get(this.baseURL + "website/getUploadUrl", {
        params: {
          userId: this.userInfo.userId,
          token: this.userInfo.token,
        },
      });
      if (!data.host) {
        this.$store.getters.warning.warningMsg = data.status_message || "error";
        this.$store.getters.warning.warningFalg = true;
        return false;
      } else {
        return data;
      }
    },
    async uploadImgToOSS(uploadUrlInfo, fileInfo) {
      const file = fileInfo.file;
      if(!this.handleCheckUploadFileSize(file)) return false
      const fileNameList=file.name.split(".")
      const fileType=fileNameList[fileNameList.length-1]
      const key = `${uploadUrlInfo.dir}/${new Date().valueOf()}.${fileType}`;
      const formData = new FormData();
      formData.append("name", file.name);
      formData.append("key", key);
      formData.append("policy", uploadUrlInfo.policy);
      formData.append("OSSAccessKeyId", uploadUrlInfo.accessid);
      formData.append("success_action_status", "200");
      formData.append("callback", uploadUrlInfo.callback || "");
      formData.append("signature", uploadUrlInfo.signature);
      formData.append("file", file);
      const res = await axios.post(uploadUrlInfo.host, formData);
      if (res.status == 200) return key;
      this.$store.getters.warning.warningMsg = res.statusText || "error";
      this.$store.getters.warning.warningFalg = true;
      return false;
    },
    async uploadImg(param) {
      const uploadUrlInfo = await this.getUploadUrl();
      if (!uploadUrlInfo) return this.uploadImgSuccessCount++;
      const ossRes = await this.uploadImgToOSS(uploadUrlInfo, param);
      if (!ossRes) return this.uploadImgSuccessCount++;
      this.formData.langMaps[this.uploadImgSuccessCount].fileUrl=ossRes
      this.uploadImgSuccessCount++
    },
    formValidateAndSubmit(){
      if(!this.id&&this.uploadImgSuccessCount!=3) return 
      this.$refs["detailInfo"].validate(async (valid) => {
        if (valid) {
          const param = {
            ...this.formData,
            ...this.userInfo
            }
          if(this.id) param.id=this.id  
          const {
            data: { status_code, status_message },
          } = await axios.post(
            this.baseURL +( this.id?"websitePartnership/update":"websitePartnership/create"),
            param
          );
          if (status_code == "0") {
          } else {
            this.$store.getters.warning.warningMsg = status_message;
            this.$store.getters.warning.warningFalg = true;
          }
        } else {
          this.$toastr.w(this.$i18n.t("message.fillRequired"));
          return false;
        }
      });
      this.uploadImgSuccessCount = 0
    },
    async handleSubmit() {
      for(let i=0;i<this.formData.langMaps.length;i++){
        await this.$refs[`upload${this.formData.langMaps[i].lang}`][0].submit()
      }
    },
    handleBack() {
      this.$router.go(-1)
    },
    handleCheckUploadFileSize(file){
      const sizeKB = file.size/1024
      if(sizeKB>5120){
        this.uploadErr = true
        return false
      }else{
        this.uploadErr = false
        return true
      }
    }
  },
};
</script>
<style lang="scss" scoped>
::v-deep .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
</style>
